<template>
  <div id="app-ct" :class="{ desk: judeIsElectron() }">
    <desk-header v-if="judeIsElectron()"></desk-header>
    <div
      id="app"
      :class="{ 'is-mobile': is_mobile }"
      v-if="show_project_status"
    >
      <div class="env" v-if="show_tip">测试环境</div>
      <!-- <router-view/> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive">
          <!--这里是会被缓存的路由-->
        </router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <interaction v-if="!isElectron()"></interaction>
      <!-- jp首次登录 -->
      <firstLogin></firstLogin>
      <!-- jp账号过期续费提示 -->
      <jpAccountExpiredToast></jpAccountExpiredToast>
      <!-- <interaction :key="$store.state.interaction.class_id"></interaction> -->
      <!-- electron付费 -->
      <paidModal></paidModal>
      <!-- 第三方账号绑定 -->
      <bindThirdPartner></bindThirdPartner>
    </div>
  </div>
</template>

<script>
import { getSchoolServerApi } from "./api/commonApi";
import deskHeader from "@/components/deskHeader/deskHeader";
import paidModal from "@/components/paidModal/index";
import bindThirdPartner from "@/components/bindThirdPartner/index";
export default {
  name: "app-ct",
  data() {
    return {
      timer: null,
      show_tip: false,
      is_mobile: false,
      show_project_status: false,
      no_get_user_info_url: [
        "electronLogin",
        "login",
        "jpLogin",
        "register",
        "register-login",
        "ground",
        "forget-password",
        "error",
        "wwxAuthSuccess",
      ], // 不请求账户信息的页面
    };
  },
  components: {
    deskHeader,
    paidModal,
    bindThirdPartner,
  },
  computed: {
    getOrgCode() {
      return this.$store.getters.getOrgCode;
    },
  },
  watch: {
    $route(to, from) {
      this.jpAccountAction();

      if (!this.judeIsElectron()) {
        this.electronAccountAction();
      }
    },
    getOrgCode() {
      if (this.checkIsHxz()) {
        window.document.documentElement.setAttribute("data-theme", "hxz");
      } else {
        window.document.documentElement.setAttribute("data-theme", "");
      }
    },
  },
  methods: {
    getOrganization() {
      this.$store
        .dispatch("GET_ORGANIZATION")
        .then((res) => {
          this.show_project_status = true;
        })
        .catch((err) => {
          let str =
            "<div class='network-err-tip' style='width: 100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction: column;'><p>网络连接出错啦，请检测网络是否正常</p><p>net::ERR_CONNECTION_CLOSED</p><button style='background:#1c94fa;color:#fff;border:none;padding: 0.1rem 0.15rem;'>点击重试</button></div>";
          $(".network-err-tip").remove();
          $("body").append(str);
          $(document).on("click", ".network-err-tip", function () {
            window.location.reload();
          });
          throw new Error(err);
        });
    },
    getSchoolServer() {
      getSchoolServerApi()
        .then((res) => {
          if (res.errCode == 0) {
            this.$store.commit(
              "localip",
              res.data.host_name_map_school_server_id
            );
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    checkout() {
      this.timer = setInterval(
        function () {
          if (this.$cookies.get("class_id")) {
            console.log("执行本地化");
            this.getSchoolServer();
            clearInterval(this.timer);
          }
        }.bind(this),
        3000
      );
    },
    //存取设备信息
    cache_equipment_info() {
      if (
        this.$cookies.get("akadm_device_mac") ||
        typeof IMAppObj == "undefined" ||
        this.$cookies.get("user_type") != 2
      ) {
        return;
      }
      this.$cookies.set(
        "akadm_device_mac",
        JSON.parse(IMAppObj.getDeviceInfo()).mac
      );
    },
    checkJpAccountInfo() {
      let jpAccountInfo = this.$store.getters.getJpAccountRenewInfo;
      if (JSON.stringify(jpAccountInfo) == "{}") {
        if (
          this.$cookies.get("user_type") == 1 &&
          this.$cookies.get("jp_teacher_class_id")
        ) {
          let data = {
            class_id: this.$cookies.get("jp_teacher_class_id"),
          };
          this.$store.dispatch("CHECK_JP_RENEW_IFNO", data);
        }
        if (this.$cookies.get("user_type") == 2) {
          let data = {
            class_id: this.$cookies.get("class_id"),
          };
          this.$store.dispatch("CHECK_JP_RENEW_IFNO");
        }
      }
    },
    checkIsJpAccountAndfirstLogin() {
      let data = {
        org_code: this.org_code(),
      };
      this.$store.dispatch("CHECK_JP_IS_FIRST_LOGIN", data);
    },
    jpAccountAction() {
      if (
        this.org_code() &&
        this.org_code() == "jp" &&
        this.$route.name != "jpLogin" &&
        this.$route.name != "forget-password" &&
        this.$route.name != "register" &&
        this.$route.name != "ground"
      ) {
        // 检测是否为jp账号状态信息
        this.checkJpAccountInfo();
        // 检测是否为jp教师账号且第一次登陆
        if (this.$cookies.get("user_type") == 1 && !this.isPc()) {
          this.checkIsJpAccountAndfirstLogin();
        }
      }
    },
    electronAccountAction() {
      // 教师端
      if (this.no_get_user_info_url.indexOf(this.$route.name) == -1) {
        this.$store.dispatch("ELECTRON_ACCOUNT_INFO");
      }
    },
    check_is_mobile() {
      let deviceWidth = document.documentElement.clientWidth;
      this.is_mobile = !this.isPc() && deviceWidth < 600;
    },
    domainTitle() {
      console.log(document.title, localStorage.getItem("common_page_title"),22222)
      console.log(localStorage.getItem("common_favicon"),33333)
      // document.title = this.judeIsElectron() ? "爱米云课件" : document.title;
      document.title = localStorage.getItem("common_page_title");
      let link = document.getElementById("link-icon");
      link.href =  localStorage.getItem("common_favicon");
    },
    // checkSchoolWorkr(school_ip){
    //   const data = {
    //     request_cross_domain:"four.akdm.com"
    //   }
    //    checkSchoolWorkrApi(data,school_ip)
    //     .then(res => {
    //       console.log(res);
    //       if(res.data.errCode == 0){
    //         console.log(res);
    //         this.$store.commit('checkwork', {
    //           is_work: res.data.data.is_work
    //         })
    //       }else{
    //         this.$message(res.data.msg);
    //         console.log(res.data.msg);
    //       }
    //   })
    //   .catch(err => {
    //     this.$store.commit('checkwork', {
    //         is_work: true
    //     })
    //     throw new Error(err);
    //   });
    // },
  },
  created() {
    this.getOrganization();
  },
  mounted() {
    // this.checkout();
    this.show_tip = env_config.show_tip;
    setInterval(() => {
      this.cache_equipment_info();
    }, 3000);
    window.addEventListener("resize", this.check_is_mobile);
    this.check_is_mobile();
    this.electronWindowLogout();
    this.$nextTick(()=>{
      this.domainTitle();
    })
  },
};
</script>

<style scoped lang="scss">
#app-ct {
  width: 100%;
  height: 100%;
  overflow: auto;
  ::-webkit-scrollbar-track {
    background: none;
  }
}
#app {
  width: 100%;
  height: 100%;
  overflow: auto;
  ::-webkit-scrollbar-track {
    background: none;
  }
  .env {
    display: inline-flex;
    justify-content: center; //主轴方向水平居中
    align-items: center;
    position: absolute;
    // right: 0;
    // left: 0;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0.02rem;
    color: #999999;
    z-index: 99999999999;
  }
}
#app-ct.desk {
  background-color: transparent;
}
.desk #app {
  height: calc(100% - 0.32rem) !important;
}
</style>

